import { render, staticRenderFns } from "./propertyStaff.vue?vue&type=template&id=4ea22de7"
import script from "./propertyStaff.vue?vue&type=script&lang=js"
export * from "./propertyStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports